import { render, staticRenderFns } from "./AdminRejectReasonForm.vue?vue&type=template&id=3f144c26&scoped=true&"
import script from "./AdminRejectReasonForm.vue?vue&type=script&lang=js&"
export * from "./AdminRejectReasonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f144c26",
  null
  
)

export default component.exports